import { UiPlacement, UiPlacementResponse } from '@/types/api/ui-placement'

import { UiPlacementPlacement } from '@/types/api/ui-placement'

import { api } from '@/api'
import { MenuItemsType } from '@/components/v2/organisms/navigation/navigation-index/navigation-index'
import { HIDDEN_CATEGORIES, HIDDEN_SUBCATEGORIES } from '@/constants'
import { ErrorCode } from '@/errors/errorCode'
import { UiPlacementType } from '@/types/api/ui-placement'

export async function fetchMenuItems(
  fetchOptions?: RequestInit
) {
  const [err, uiPlacement] = await api.be.uiPlacement.getMany(
    {
      placement: [
        UiPlacementPlacement.MAIN_MENU,
        UiPlacementPlacement.SUB_MENU,
      ],
      type: [
        UiPlacementType.BUSINESS_CATEGORY,
        UiPlacementType.ARTICLE_CATEGORY,
        UiPlacementType.ARTICLE_SUBCATEGORY,
        UiPlacementType.METADATA,
        UiPlacementType.TAG,
      ],
    },
    fetchOptions
  )

  if (err) {
    console.log(ErrorCode.e00046, err)
    throw err
  }

  return uiPlacement
}

export async function fetchMenuArticles(
  mainCategories: string[],
) {
  const featuredArticles = []

  for (const category of mainCategories) {
    const [errArt, articles] = await api.be.article.search({
      pageSize: 6,
      sort: 'published_at_desc',
      category: category,
    })

    if (errArt) {
      console.log(ErrorCode.e00045, category, errArt)
    }

    if (articles) {
      featuredArticles.push(...articles.results)
    }
  }

  return featuredArticles
}

export const getMainNavCategories = (
  menuItems: UiPlacementResponse['data']
) => {
  const main = [
    ...menuItems[UiPlacementType.ARTICLE_CATEGORY]?.[
    UiPlacementPlacement.MAIN_MENU
    ],
    ...(menuItems.metadata
      ? menuItems.metadata?.[UiPlacementPlacement.MAIN_MENU]
      : []),
  ]

  return main
    .filter((item) => item.article_category_id)
    .map((item) => item.article_category_id!)
}

export function groupMenuItems(
  data: UiPlacementResponse['data']
): MenuItemsType {
  const main = [
    ...data[UiPlacementType.ARTICLE_CATEGORY]?.[UiPlacementPlacement.MAIN_MENU],
    ...(data.metadata ? data.metadata[UiPlacementPlacement.MAIN_MENU] : []),
  ]
  const child = [
    ...data[UiPlacementType.ARTICLE_SUBCATEGORY]?.[
    UiPlacementPlacement.SUB_MENU
    ],
    ...data[UiPlacementType.BUSINESS_CATEGORY]?.[UiPlacementPlacement.SUB_MENU],
    ...data[UiPlacementType.TAG]?.[UiPlacementPlacement.SUB_MENU],
  ]

  const combinedItems = main
    .map((item) => {
      const subItems = child
        .filter(
          (subcategory) =>
            !HIDDEN_SUBCATEGORIES.includes(
              subcategory.article_subcategory_id!
            ) &&
            !HIDDEN_CATEGORIES.includes(subcategory.metadata?.overrides?.slug!)
        )
        .filter((subItem: UiPlacement) => {
          // this one is hardcoded because we don't have a way to connect these values on the be
          const isWeddingSuppliers = item.metadata?.slug === 'wedding-suppliers'
          const isWeddingVenues = item.metadata?.slug === 'wedding-venues'

          if (isWeddingSuppliers) {
            return subItem.metadata?.mainMenuItemName === 'suppliers'
          }

          if (isWeddingVenues) {
            return subItem.metadata?.mainMenuItemName === 'venues'
          }

          const isChildOfMainCategory =
            subItem.article_subcategories?.parent_slug ===
            item.article_category_id ||
            subItem.metadata?.overrides?.article_category_id ===
            item.article_category_id

          return isChildOfMainCategory
        })
        .toSorted((a, b) => a.sort_order - b.sort_order)

      return {
        mainItem: item,
        subcategories: subItems,
      }
    })
    .toSorted((a, b) => a.mainItem.sort_order - b.mainItem.sort_order)

  return combinedItems
}
